var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import 'rc-trigger/assets/index.css';
import Trigger from 'rc-trigger';
var builtinPlacements = {
    left: {
        points: ['cr', 'cl'],
    },
    right: {
        points: ['cl', 'cr'],
    },
    top: {
        points: ['bc', 'tc'],
    },
    bottom: {
        points: ['tc', 'bc'],
    },
    topLeft: {
        points: ['bl', 'tl'],
    },
    topRight: {
        points: ['br', 'tr'],
    },
    bottomRight: {
        points: ['tr', 'br'],
    },
    bottomLeft: {
        points: ['tl', 'bl'],
    },
};
var Popup = function (_a) {
    var children = _a.children, trigger = _a.trigger, popupVisible = _a.popupVisible, onPopupVisibleChange = _a.onPopupVisibleChange, popup = _a.popup, popupPlacement = _a.popupPlacement, popupContainerScreenPosition = _a.popupContainerScreenPosition;
    var _b = useState(popupVisible !== null && popupVisible !== void 0 ? popupVisible : false), isVisible = _b[0], setIsVisible = _b[1];
    var _c = useState(), offset = _c[0], setOffset = _c[1];
    return (_jsx(Trigger, __assign({ action: trigger !== null && trigger !== void 0 ? trigger : 'hover', builtinPlacements: builtinPlacements, popupPlacement: popupPlacement, popup: popup, popupVisible: popupVisible !== null && popupVisible !== void 0 ? popupVisible : isVisible, popupAlign: { offset: offset }, onPopupAlign: function (popupElement) {
            var alignOffset = [0, 0];
            var floatPopupLeft = parseFloat(popupElement.style.left);
            if (!!popupContainerScreenPosition &&
                floatPopupLeft > 0 &&
                floatPopupLeft < popupContainerScreenPosition) {
                alignOffset = [1, 0];
            }
            setOffset(alignOffset);
            return popupElement;
        }, onPopupVisibleChange: function (visible) {
            onPopupVisibleChange === null || onPopupVisibleChange === void 0 ? void 0 : onPopupVisibleChange(visible);
            setIsVisible(visible);
        } }, { children: children })));
};
export default Popup;
